import request from '@/utils/request'

//  新增商品 - 获取属性组
export const goodsPropertyList = (pageData) => {
    return request.get(`/propertyGroup/goodsPropertyList/${pageData.page}/${pageData.pageSize}`)
}

// 获取属性组列表
export const listPropertyGroup = (pageData, formData) => {
    return request.get(`/propertyGroup/${pageData.page}/${pageData.pageSize}`, {params:{propertyGroupName: formData.propertyGroupName}})
}

// 新增属性项
export const addPropertyGroup = (formData) => {
    return request.post('/propertyGroup', formData)
}

// 获取属性组详情
export const propertyGroupItem = (id) => {
    return request.get(`/propertyGroup/${id}`)
}

// 修改属性项
export const editPropertyGroup = (updateData) => {
    return request.put('/propertyGroup', updateData)
}

//  删除驿站
export const removePropertyGroup = (id) => {
    return request.delete(`/propertyGroup/${id}`)
}